import React,{Component} from 'react';
import {toast, ToastContainer} from "react-toastify";
import {bindActionCreators} from "redux";
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SaleLists from '../../presentational/sale-list';

require('dotenv').config();

toast.configure({
    autoClose: 2000,
    draggable: false,
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}


class Sales extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            loadingZipcode: false,
            errors: {},
            search: '',

            showDetail: false,
            showForm: false,
            showFormEdit: false,
            showPassword: false,
            showEdit:false,

            value: 0,
            rows: [],
            rowsActivity: [],

            id: '',
            name: '',
            accountNumber: '',
            contact: [],
            address: '',
            loginType: '',
            loginSince: '',
            accountCreated: '',

            payments: [],
            vehicles: [],
            transactions: [],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.__fetchData(false);
    }

    __fetchData = update => {

    };

    handleChange (e, newValue){

        this.setState({

            value: newValue

        })
    };


    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <AppBar position="static" color="default">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <h2>Transponder Purchase</h2>
                            </div>
                        </div>

                        <Tabs
                            value={this.state.value}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            <Tab label="Ordered" {...a11yProps(0)} />
                            <Tab label="Sent" {...a11yProps(1)} />
                            <Tab label="Delivered" {...a11yProps(2)} />
                        </Tabs>
                    </AppBar>

                    <TabPanel value={this.state.value} index={0}>
                        <SaleLists OrderType="ordered"/>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                        <SaleLists OrderType="sent"/>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={2}>
                        <SaleLists OrderType="delivered"/>
                    </TabPanel>
                </div>
                <ToastContainer />
            </div>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        permission_state: state.permission_state,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Sales);